<template>
  <v-layout
    wrap
    justify-end
  >
    <v-flex
      md2
      xs6
      pb-0
      class="dates-toolbar"
    >
      <v-menu
        v-model="PickerFrom"
        :close-on-content-click="false"
        :nudge-right="40"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :disabled="$apollo.loading"
            :value="fromDate"
            :label="$t('globals.from')"
            prepend-icon="mdi-calendar"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker 
          v-model="params.fromDate" 
          :locale="$i18n.locale"
          :min="minDate"
          :max="params.toDate || $moment().format('YYYY-MM-DD')"
          @input="PickerFrom = false"
          @change="reload( 'fromDate', params.fromDate)"
        />
      </v-menu>
    </v-flex>
    <v-flex
      md2
      xs6
      pb-0
      class="dates-toolbar"
    >
      <v-menu
        v-model="PickerTo"
        :close-on-content-click="false"
        :nudge-right="40"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :disabled="$apollo.loading"
            :value="toDate"
            :label="$t('globals.to')"
            prepend-icon="mdi-calendar"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker 
          v-model="params.toDate" 
          :locale="$i18n.locale"
          :min="params.fromDate || minDate"
          :max="endDate"
          @input="PickerTo = false"
          @change="reload('toDate', params.toDate)"
        />
      </v-menu>
    </v-flex>
    <v-flex md12>
      <v-skeleton-loader
        v-if="$apollo.loading"
        type="table-tbody"
        :tile="true"
        class="mx-auto"
        width="100%"
        max-height="268"
      />
      <v-data-table  
        v-if="!$apollo.loading && !_.isEmpty(connectionBalanceHistory.data)" 
        class="text-no-wrap" 
        :headers="headers"
        :footer-props="{
          'items-per-page-options': [10, 15, 25, 50, 100, 200]
        }"
        :locale="$i18n.locale"
        :items="connectionBalanceHistory.data"
        :items-per-page="connectionBalanceHistory.per_page"
        :page="connectionBalanceHistory.current_page"
        :server-items-length="connectionBalanceHistory.total"
        :hide-default-footer="_.isEmpty(connectionBalanceHistory.data)"
        dense
        @update:page="reload('page', $event)"
        @update:items-per-page="reload('count', $event)"
      >
        <template v-slot:item.balance="{ item }">
          <b>
            {{ item.balance | formatMoney }} {{ baseCurrency }}
          </b>
        </template> 

        <template v-slot:item.amount="{ item }">
          <b :class="colorPnL(item.amount)">
            {{ item.amount | expToFloat | formatMoney }} {{ baseCurrency }}
          </b>
        </template> 

        <template v-slot:item.created_at="{ item }">
          {{ item.created_at | moment('ll') }}
        </template> 

        <template v-slot:item.type="{ item }">
          {{ $t('accounts.'+item.type) }}
        </template>
      </v-data-table>
    </v-flex>
    <v-flex
      v-if="!$apollo.loading && _.isEmpty(connectionBalanceHistory.data)"
      md12 
      class="not-found"
    >
      <v-icon>mdi-ghost</v-icon>
      <p>{{ $t('accounts.balanceHistoryNotFound') }}</p>
    </v-flex>
  </v-layout>
</template>

<script>

const CONNECTION_BALANCE_HISTORY_QUERY = require('@/graphql/queries/ConnectionBalanceHistory.gql');


export default {
  name: 'ConnectionBalanceHistory',
  props: {
    minDate: {
      type: String,
      default() {
        return null
      }
    },
    maxDate: {
      type: String,
      default() {
        return null
      }
    },
    periodId: {
      type: String,
      default() {
        return null
      }
    },
    baseCurrency: {
      type: String,
      default: "BTC"
    }
  },
  data() {
    return {
      PickerFrom: null,
      PickerTo: null,
      loading: false,
      params: {
        period_id: this.periodId,
        fromDate: this.minDate,
        toDate: this.endDate,
        page: 1,
        count: 25
      },
      headers: [
        {
          sortable: false,
          text: this.$t('accounts.date'),
          value: 'created_at'
        },
        {
          sortable: false,
          text: this.$t('accounts.type'),
          value: 'type'
        },
         {
          sortable: false,
          text: this.$t('rankings.instrument'),
          value: 'symbol'
        },
        {
          sortable: false,
          text: this.$t('accounts.inOut'),
          value: 'amount'
        },
        {
          sortable: false,
          text: this.$t('globals.balance'),
          value: 'balance'
        },
        
      ]
    }
    
  },
  computed: {
    fromDate() {
      return this.$moment(this.params.fromDate).format('ll');
    },
    toDate() {
      return this.$moment(this.params.toDate).format('ll');
    },
    endDate() {
      return this.maxDate != null ? this.maxDate : this.$moment().add(1, 'days').format('YYYY-MM-DD HH:mm:ss')
    },
  },
  methods: {
    reload(key, value) {
      this.params[key] = value
      this.params.fromDate = this.$moment(this.params.fromDate).format('YYYY-MM-DD HH:mm:ss')
      this.params.toDate = this.$moment(this.params.toDate).format('YYYY-MM-DD HH:mm:ss')
      this.$apollo.queries.connectionBalanceHistory.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult
        },
      })
    },
  },
  apollo: {
    connectionBalanceHistory: {
      query: CONNECTION_BALANCE_HISTORY_QUERY,
      fetchPolicy: 'network',
      variables() {
        return this.params
      }
    }
  }
}
</script>

<style lang="scss">


</style>
